import request from '@/config'
import { WorkItemSearch, BillTaskSearch } from './task.type';

/* 获取工作项目列表 */
export const GetWorkItemsApi = (search: WorkItemSearch): Promise<IResponse> => {
    return request.post({ url: '/api/worktask/getworkflowlist', data: search })
}

/* 获取审核过程数据 */
export const GetWorkTimeLineApi = (contractId: string): Promise<IResponse> => {
    return request.post({ url: '/api/contract/getworkitemlist', data: { ct_id: contractId } })
}

/* 获取当前登录用户待审合同ID列表 */
export const GetWaitAuditApi = (): Promise<IResponse> => {
    return request.post({ url: '/api/worktask/getwaitauditcontract', data: {} })
}


/* 获取审批中的收付款记录 */
export const BillTaskApi = (search: BillTaskSearch): Promise<IResponse> => {
    return request.post({ url: '/api/worktask/getbillworklist', data: search })
}

/* 获取参与人 */
export const InvolvedUserList = (contractId: string ): Promise<IResponse> => {
    return request.post({ url: '/api/contract/getInvolvedList', data: { ct_id: contractId } })
}

/* 获取参与人 */
export const saveInvolvedUserList = (savedata: any ): Promise<IResponse> => {
    return request.post({ url: '/api/contract/saveInvolvedList', data: savedata })
}
